import { render, staticRenderFns } from "./CargoFormHeader.vue?vue&type=template&id=6fce3772"
import script from "./CargoFormHeader.vue?vue&type=script&lang=js"
export * from "./CargoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports